<ng-container *transloco="let t">
<ion-footer>
    <ion-row>
        <ion-nav-link [routerLink]="translateService.localize('/help')" routerDirection="root" routerLinkActive="active-link"
                      class="footer-link">{{t('help.Help')}}</ion-nav-link>&nbsp;-&nbsp;<ion-nav-link
	    [routerLink]="translateService.localize('/mentions-legales')" routerDirection="root" routerLinkActive="active-link"
	    class="footer-link">{{t('footer.legal')}}</ion-nav-link>
    </ion-row>
    <ion-row class="d-flex flex-column footer-meta">
      © {{ today | date: "yyyy" }} Slaveous {{t('footer.All rights reserved')}}
    </ion-row>
    <ion-row class="d-flex flex-column footer-meta">
      {{ actualVersion() }}
    </ion-row>
</ion-footer>

</ng-container>
